import React from 'react';


var TransferSuccessPopup = React.createClass ({
  handleStopPropogation: function(e) {
    e.stopPropagation() 
  },
  handleCancelClick: function (){
    this.props.transferSuccess("close");
  },
  handleRevokeClick: function(){
    this.props.transferSuccess("revoke");
  },
  handlePendingClick: function(){
    this.props.transferSuccess("pendingTransfers");
  },
  render: function(){
    return (
      <div className="modal__mask" onClick = {this.handleCancelClick}> 
        <div className="modal__content modal--md" onClick = {this.handleStopPropogation}>
          <div className="modal__header">
            <h3 className="modal__header--title">Success</h3>
            <a href="javascript:void(0)" className="modal__close" onClick = {this.handleCancelClick}><i className="fa  fa-close"> </i></a> </div>
          <div className="modal__body clearfix">
            <div className="form__row clearfix">
              <p>We have notified <strong>{this.props.receiver}</strong> that you have transferred <strong>"{this.props.slug}"</strong> to their account. You can still see it in your Pending Transfers until it has been accepted.</p>
            </div>
            <div className="form__row last clearfix">
              <button className="btn__lg bg-bold" onClick = {this.handleRevokeClick}>Revoke</button>
              <div className="buttons clearfix">
                <button className="btn__lg bg-very_light" onClick = {this.handlePendingClick}>Pending Transfers</button>
                <button className="btn__lg bg-bright" onClick = {this.handleCancelClick}>Ok</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      )
  }
});

export {TransferSuccessPopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/TransferSuccessPopup.jsx
 **/